var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ viewBox: "0 0 43 37" }, props),
    React.createElement(
      "g",
      { fill: "none", fillRule: "evenodd" },
      React.createElement("path", { d: "M-12-14h66v66h-66z" }),
      React.createElement("path", { d: "M1 19C1 9.059 9.059 1 19 1s18 8.059 18 18c0 9.94-8.059 18-18 18S1 28.94 1 19", fill: "#FFFFFE" }),
      React.createElement("path", { d: "M29.573 18.468c-.007-4.574-2.88-8.475-6.927-10.02v20.04c4.047-1.548 6.92-5.445 6.927-10.02zM14.926 28.483V8.45C10.882 10 8.014 13.895 8.003 18.468c.011 4.572 2.879 8.467 6.923 10.015zM18.788 1.53C9.39 1.534 1.778 9.114 1.776 18.468c.002 9.353 7.615 16.932 17.012 16.933 9.397-.001 17.012-7.58 17.014-16.933C35.8 9.114 28.185 1.534 18.788 1.53zM18.746 37C8.463 37.048 0 28.756 0 18.66 0 7.63 8.463-.002 18.746 0h4.819C33.726-.002 43 7.625 43 18.661 43 28.752 33.726 37 23.565 37h-4.819z", fill: "#0069AA" })
    )
  );
});